var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1182"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1182"
    },
    "bundlingPackage": "documents-public-ui",
    "bundlingPackageVersion": "static-1.34792",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};